function audioBufferToWavBlob(buffer) {
  const numCh = Math.min(buffer.numberOfChannels, 2);
  const sr = buffer.sampleRate;
  const frames = buffer.length;
  const bytesPerSample = 2;
  const blockAlign = numCh * bytesPerSample;
  const dataSize = frames * blockAlign;
  const ab = new ArrayBuffer(44 + dataSize);
  const view = new DataView(ab);
  const writeStr = (o, s) => { for (let i = 0; i < s.length; i++) view.setUint8(o + i, s.charCodeAt(i)); };
  writeStr(0, "RIFF");
  view.setUint32(4, 36 + dataSize, true);
  writeStr(8, "WAVE");
  writeStr(12, "fmt ");
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true);
  view.setUint16(22, numCh, true);
  view.setUint32(24, sr, true);
  view.setUint32(28, sr * blockAlign, true);
  view.setUint16(32, blockAlign, true);
  view.setUint16(34, 16, true);
  writeStr(36, "data");
  view.setUint32(40, dataSize, true);
  const chans = [];
  for (let c = 0; c < numCh; c++) chans.push(buffer.getChannelData(c));
  let off = 44;
  for (let i = 0; i < frames; i++) {
    for (let c = 0; c < numCh; c++) {
      let s = Math.max(-1, Math.min(1, chans[c][i]));
      view.setInt16(off, s < 0 ? s * 0x8000 : s * 0x7fff, true);
      off += 2;
    }
  }
  return new Blob([view], { type: "audio/wav" });
}

// Mix a melody (URL) with a recorded vocal (Blob). balance 0..1: 0 = melody loud, 1 = voice loud.
export async function mixToWav(melodyUrl, vocalBlob, balance = 0.6) {
  const AC = window.AudioContext || window.webkitAudioContext;
  const ac = new AC();
  try {
    const [melArr, vocArr] = await Promise.all([
      fetch(melodyUrl).then((r) => r.arrayBuffer()),
      vocalBlob.arrayBuffer(),
    ]);
    const [melBuf, vocBuf] = await Promise.all([
      ac.decodeAudioData(melArr.slice(0)),
      ac.decodeAudioData(vocArr.slice(0)),
    ]);
    const sr = ac.sampleRate;
    const length = Math.max(melBuf.length, vocBuf.length);
    const off = new OfflineAudioContext(2, length, sr);
    const m = off.createBufferSource(); m.buffer = melBuf;
    const v = off.createBufferSource(); v.buffer = vocBuf;
    const mg = off.createGain(); mg.gain.value = 1 - balance * 0.85;
    const vg = off.createGain(); vg.gain.value = 0.6 + balance * 0.8;
    m.connect(mg).connect(off.destination);
    v.connect(vg).connect(off.destination);
    m.start(0); v.start(0);
    const rendered = await off.startRendering();
    return audioBufferToWavBlob(rendered);
  } finally {
    ac.close();
  }
}
